import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgChevronDoubleRight = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M4.307 2.713A.75.75 0 0 1 5 2.25h6a.75.75 0 0 1 .53.22l9 9a.75.75 0 0 1 0 1.06l-9 9a.75.75 0 0 1-.53.22H5a.75.75 0 0 1-.53-1.28L12.94 12 4.47 3.53a.75.75 0 0 1-.163-.817M6.811 3.75l7.72 7.72a.75.75 0 0 1 0 1.06l-7.72 7.72h3.878L18.94 12l-8.25-8.25z"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgChevronDoubleRight;
